import React, { ReactNode, createContext } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { ConfigProvider } from "antd";

interface GlobalContextType {
  query?: {
    allPages?: {
      edges: any[];
    };
    allSitePage?: any;
  };
}

const GlobalContext = createContext<GlobalContextType>({});

interface GlobalContextProviderProps {
  children: ReactNode;
}

export const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({ children }) => {
  const query = useStaticQuery(graphql`
    {
      allSitePage {
        nodes {
          path
          pageContext
        }
      }

      allPages: allMarkdownRemark(filter: {
        fields: {type: {eq: "website_pages"}},
      }) {
        edges {
          node {
            fields {
              slug
              name
              language
            }
            frontmatter {
              title
            }
          }
        }
      }

    }
  `);

  return <ConfigProvider
    theme={{
      token: {
        fontFamily: 'Montserrat, sans-serif',
        fontFamilyHeading: 'Montserrat, sans-serif',
        colorPrimary: '#058b8c',
        colorText: 'black',
        colorTextHeading: 'black',
        colorTextSecondary: 'black',
        colorBtnPrimaryBg: '#058b8c', // Button primary background
        colorBtnPrimaryColor: 'white', // Button primary text color
        colorBtnSecondaryBg: '#383e42', // Button primary background
        colorBtnSecondaryColor: 'white', // Button primary text color
        colorBgContainer: 'white', // Background color
        colorBgLayout: 'white', // Layout background color
        colorBorder: '#f0f0f0', // Border color
        colorInfo: '#50a8b0',   // Same as primary
        colorSuccess: '#50a8b0',   // Same as primary
        borderRadius: 3,
      },
      components: {
        Menu: {
          itemHeight: 80,
          colorBgBase: "black",
          colorPrimaryActive: "red",
        },
        Row: {
          gutter: [5, 5],
        },
        Button: {
          borderColorDisabled: '#058b8c',
          contentFontSizeLG: 20,
          fontWeight: 600,
          primaryShadow: 'none',
          defaultShadow: 'none',
        },
        Segmented: {
          itemSelectedBg: "#058b8c",
          itemSelectedColor: "white",
        },
        Select: {
        }
      },
    }}
  >

    <GlobalContext.Provider
      value={{
        query,
      }}
    >
      {children}
    </GlobalContext.Provider>
  </ConfigProvider>
};

export default GlobalContext;
